import './CourseApp.less';
import React, {useEffect, useRef} from 'react';
import {useParams} from 'react-router-dom';
import useCourse from "../../hooks/useCourse";
import Header from "./header/Header";
import ObjectivesSection from "./objectives-section/ObjectivesSection";
import ContentSection from "./content-section/ContentSection";
import RequirementsSection from "./requirements-section/RequirementsSection";
import IntroductionSection from "./introduction-section/IntroductionSection";
import Sidebar from "./sidebar/Sidebar";
import LoadingPlaceholder from "../../components/loading-placeholder/LoadingPlaceholder";
import {jsonToObject} from "../../../bootstrap/utils/json";


export default function CourseApp() {
    const {slug} = useParams();

    const [course, refs, isLoading] = useCourse(slug, [
        'chapter',
        'lesson',
        'user',
        'image',
        'video',
        'enrollment',
        'promotion',
        'quiz',
        'question',
        'question_group',
    ]);

    const backgroundRef = useRef(null);

    const headerRef = useRef(null);

    useEffect(() => {
        if (headerRef.current !== null && backgroundRef.current !== null) {
            backgroundRef.current.style.height = headerRef.current.offsetHeight + 'px';
        }
    });

    if (isLoading) {
        return <LoadingPlaceholder/>;
    }

    if (course === null) {
        return null;
    }

    const avatarImage = refs.images.find(t => t.id === course.avatar_image_id);

    const creator = refs.users.find(t => t.id === course.creator_id);

    const enrollment = refs.enrollments.find(t => t.course_id === course.id) || null;

    const chapters = refs.chapters;

    const lessons = refs.lessons;

    const videos = refs.videos;

    const promotion = refs.promotions.find(t => t.id === course.promotion_id);

    const questionGroups = refs.questionGroups;

    const questions = refs.questions;

    const objectives = textToLines(course.objectives);

    const requirements = textToLines(course.requirements);

    const introduction = jsonToObject(course.introduction);

    return <div className="course-app">
        <div className="background" ref={backgroundRef}/>
        <div className="inner">
            <Header
                ref={headerRef}
                course={course}
                creator={creator}
            />
            <Sidebar
                course={course}
                promotion={promotion}
                avatarImage={avatarImage}
                lessons={lessons}
                videos={videos}
                enrollment={enrollment}
            />
            {
                objectives.length > 0 &&
                <ObjectivesSection
                    objectives={objectives}
                />
            }
            <ContentSection
                course={course}
                chapters={chapters}
                lessons={lessons}
                videos={videos}
                questionGroups={questionGroups}
                questions={questions}
            />
            {
                requirements.length > 0 &&
                <RequirementsSection
                    requirements={requirements}
                />
            }
            {
                introduction !== null &&
                <IntroductionSection
                    introduction={introduction}
                />
            }
        </div>
    </div>;
}


function textToLines(text) {
    text = text || '';
    return text.split('\n').map(t => t.trim()).filter(t => t);
}
